import { Action } from '@ngrx/store';

import { TopFlop } from '../../../../models/tops-flops/top-flop';
import { DocumentWithId } from '../../../../../../../shared/services/db/models/document-with-type';

export const ADD_TOP_FLOP = '[XENA] ADD_TOP_FLOP';
export const ADD_TOP_FLOP_SUCCESS = '[XENA] ADD_TOP_FLOP_SUCCESS';
export const REMOVE_TOP_FLOP = '[XENA] REMOVE_TOP_FLOP';
export const REMOVE_TOP_FLOP_SUCCESS = '[XENA] REMOVE_TOP_FLOP_SUCCESS';
export const UPDATE_TOP_FLOP = '[XENA] UPDATE_TOP_FLOP';
export const UPDATE_TOP_FLOP_SUCCESS = '[XENA] UPDATE_TOP_FLOP_SUCCESS';
export const LOAD_TOP_FLOP_SUCCESS = '[XENA] LOAD_TOP_FLOP_SUCCESS';
export const RESET_TOPS_FLOPS = '[XENA] RESET_TOPS_FLOPS';

export class AddTopFlopAction implements Action {
	readonly type = ADD_TOP_FLOP;

	constructor(public payload: TopFlop) {}
}

export class AddTopFlopSuccessAction implements Action {
	readonly type = ADD_TOP_FLOP_SUCCESS;

	constructor(public payload: TopFlop) {}
}

export class RemoveTopFlopAction implements Action {
	readonly type = REMOVE_TOP_FLOP;

	constructor(public payload: TopFlop) {}
}

export class RemoveTopFlopSuccessAction implements Action {
	readonly type = REMOVE_TOP_FLOP_SUCCESS;

	constructor(public payload: DocumentWithId) {}
}

export class UpdateTopFlopAction implements Action {
	readonly type = UPDATE_TOP_FLOP;

	constructor(public payload: TopFlop) {}
}

export class UpdateTopFlopSuccessAction implements Action {
	readonly type = UPDATE_TOP_FLOP_SUCCESS;

	constructor(public payload: TopFlop) {}
}

export class LoadTopFlopSuccessAction implements Action {
	readonly type = LOAD_TOP_FLOP_SUCCESS;

	constructor(public payload: Array<TopFlop>) {}
}

export class ResetTopsFlopsAction implements Action {
	readonly type = RESET_TOPS_FLOPS;
}

export type All
	= AddTopFlopAction
	| AddTopFlopSuccessAction
	| RemoveTopFlopAction
	| RemoveTopFlopSuccessAction
	| UpdateTopFlopAction
	| UpdateTopFlopSuccessAction
	| LoadTopFlopSuccessAction
	| ResetTopsFlopsAction;



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/components/tops-flops/state-management/actions/tops-flops.ts